module.exports = __webpack_public_path__ + "img/chevron-right.20ef2c6d.svg";